import { useEffect, useState } from "react"

import { Page, Text, View, Document, Image, StyleSheet, Font } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    heading1: {
        fontFamily: 'Times-Bold',
        fontSize: 13
    },
    heading2: {
        fontFamily: 'Times-Roman',
        fontSize: 9
    },
    documentName: {
        fontFamily: 'Times-Bold',
        fontSize: 15,
        textAlign: 'center'
    },
    documentNumber: {
        fontFamily: 'Times-Bold',
        fontSize: 15,
        textAlign: 'center'
    }
});

export function Header({ pageNumber, totalPages, document }) {

    if (!document) return false

    const {
        header,
        documentName,
        documentNumber,
    } = document;

    // const {
    //     lines: headerLines = []
    // } = header

    const headerLines = header?.lines ? header.lines : []

    return (
        <View style={styles.textDefault}>
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    // borderBottomColor: '#000',
                    // borderBottomStyle: 'solid',
                    // borderBottomWidth: 0.5,
                }}
            >
                <View
                    style={{
                        width: '60%',
                        flexWrap: 'wrap'
                    }}>
                    {/* <Text style={styles.heading1}>{billerCompany}</Text> */}
                    {
                        headerLines.map((i, index) => {

                            // if(!i) return <Box key={index}></Box>

                            return (
                                <Text
                                    key={index}
                                    style={
                                        index === 0 ? styles.heading1 : styles.heading2
                                    }
                                >{i}</Text>
                            )
                        })
                    }
                    {/* <Text
                        style={styles.heading2}
                    >
                    {billerContact}
                    </Text>  */}
                </View>
                <View
                    style={{
                        width: '35%',
                        // flex: 1
                    }}
                >
                    <View
                        style={{
                            borderTopWidth: 1,
                            borderTopStyle: 'solid',
                            borderTopColor: '#000',

                            borderBottomWidth: 1,
                            borderBottomStyle: 'solid',
                            borderBottomColor: '#000',

                            borderLeftWidth: 1,
                            borderLeftStyle: 'solid',
                            borderLeftColor: '#000',

                            borderRightWidth: 1,
                            borderRightStyle: 'solid',
                            borderRightColor: '#000',

                            paddingTop: 2,
                            paddingBottom: 2,
                            paddingLeft: 4,
                            paddingRight: 4,

                            marginBottom: 5,

                        }}
                    >
                        <Text
                            style={styles.documentName}
                        >
                            {documentName.toUpperCase()}
                        </Text>
                    </View>
                    <View>
                        <Text style={styles.documentNumber}>
                            {documentNumber}
                        </Text>

                    </View>
                </View>
            </View>
        </View>
    )
}
